<template>
  <div id="app">
    <marquee class="ticker" width="100%" direction="left" height="30%">Score: Computer {{ this.cpuWins }} Player {{ this.userWins}}</marquee>
    <div class="grid-container">
      <PointGuard class="grid-item1" v-bind:shown="this.pointsShown" v-bind:image="this.cpuImages[0]" v-bind:jerseynumber="this.cpuPlayers[0].player.JerseyNumber" v-bind:position="this.cpuPlayers[0].player.Position" v-bind:team="this.cpuPlayers[0].team.Name" v-bind:points="this.cpuPlayers[0].stats.Pts['#text']" v-bind:firstname="this.cpuPlayers[0].player.FirstName" v-bind:lastname="this.cpuPlayers[0].player.LastName"/>
      <ShootingGuard class="grid-item2" v-bind:shown="this.pointsShown" v-bind:image="this.cpuImages[1]" v-bind:jerseynumber="this.cpuPlayers[1].player.JerseyNumber" v-bind:position="this.cpuPlayers[1].player.Position" v-bind:team="this.cpuPlayers[1].team.Name" v-bind:points="this.cpuPlayers[1].stats.Pts['#text']" v-bind:firstname="this.cpuPlayers[1].player.FirstName" v-bind:lastname="this.cpuPlayers[1].player.LastName"/>
      <SmallForward class="grid-item3" v-bind:shown="this.pointsShown" v-bind:image="this.cpuImages[2]" v-bind:jerseynumber="this.cpuPlayers[2].player.JerseyNumber" v-bind:position="this.cpuPlayers[2].player.Position" v-bind:team="this.cpuPlayers[2].team.Name" v-bind:points="this.cpuPlayers[2].stats.Pts['#text']" v-bind:firstname="this.cpuPlayers[2].player.FirstName" v-bind:lastname="this.cpuPlayers[2].player.LastName"/>
      <PowerForward class="grid-item4" v-bind:shown="this.pointsShown" v-bind:image="this.cpuImages[3]" v-bind:jerseynumber="this.cpuPlayers[3].player.JerseyNumber" v-bind:position="this.cpuPlayers[3].player.Position" v-bind:team="this.cpuPlayers[3].team.Name" v-bind:points="this.cpuPlayers[3].stats.Pts['#text']" v-bind:firstname="this.cpuPlayers[3].player.FirstName" v-bind:lastname="this.cpuPlayers[3].player.LastName"/>
      <Center class="grid-item5" v-bind:shown="this.pointsShown" v-bind:image="this.cpuImages[4]" v-bind:jerseynumber="this.cpuPlayers[4].player.JerseyNumber" v-bind:position="this.cpuPlayers[4].player.Position" v-bind:team="this.cpuPlayers[4].team.Name" v-bind:points="this.cpuPlayers[4].stats.Pts['#text']" v-bind:firstname="this.cpuPlayers[4].player.FirstName" v-bind:lastname="this.cpuPlayers[4].player.LastName"/>
    </div>
    <button class='btn btn-grn' v-show="!this.pointsShown" v-on:click="compare()">Play</button>
    <button class='btn btn-org' v-show="this.pointsShown" v-on:click="playAgain()">Play Again</button>
    <div class="grid-container2">
      <div id="grid-item1">
        <PointGuard v-bind:shown="this.pointsShown" v-bind:image="this.userImages[0]" v-bind:jerseynumber="this.userPlayers[0].player.JerseyNumber" v-bind:position="this.userPlayers[0].player.Position" v-bind:team="this.userPlayers[0].team.Name" v-bind:points="this.userPlayers[0].stats.Pts['#text']" v-bind:firstname="this.userPlayers[0].player.FirstName" v-bind:lastname="this.userPlayers[0].player.LastName"/>
        <button id="pg" class="btn btn-red" v-on:click="swapPG($event)">Swap</button>
      </div>
      <div id="grid-item2">
        <ShootingGuard v-bind:shown="this.pointsShown" v-bind:image="this.userImages[1]" v-bind:jerseynumber="this.userPlayers[1].player.JerseyNumber" v-bind:position="this.userPlayers[1].player.Position" v-bind:team="this.userPlayers[1].team.Name" v-bind:points="this.userPlayers[1].stats.Pts['#text']" v-bind:firstname="this.userPlayers[1].player.FirstName" v-bind:lastname="this.userPlayers[1].player.LastName"/>
        <button id='sg' class="btn btn-red" v-on:click="swapSG($event)">Swap</button>
      </div>
      <div id="grid-item3">
        <SmallForward v-bind:shown="this.pointsShown" v-bind:image="this.userImages[2]" v-bind:jerseynumber="this.userPlayers[2].player.JerseyNumber" v-bind:position="this.userPlayers[2].player.Position" v-bind:team="this.userPlayers[2].team.Name" v-bind:points="this.userPlayers[2].stats.Pts['#text']" v-bind:firstname="this.userPlayers[2].player.FirstName" v-bind:lastname="this.userPlayers[2].player.LastName"/>
        <button id='sf' class="btn btn-red" v-on:click="swapSF($event)">Swap</button>
      </div>
      <div id="grid-item4">
        <PowerForward v-bind:shown="this.pointsShown" v-bind:image="this.userImages[3]" v-bind:jerseynumber="this.userPlayers[3].player.JerseyNumber" v-bind:position="this.userPlayers[3].player.Position" v-bind:team="this.userPlayers[3].team.Name" v-bind:points="this.userPlayers[3].stats.Pts['#text']" v-bind:firstname="this.userPlayers[3].player.FirstName" v-bind:lastname="this.userPlayers[3].player.LastName"/>
        <button id='pf' class="btn btn-red" v-on:click="swapPF($event)">Swap</button>
      </div>
      <div id="grid-item5">
        <Center v-bind:shown="this.pointsShown" v-bind:image="this.userImages[4]" v-bind:jerseynumber="this.userPlayers[4].player.JerseyNumber" v-bind:position="this.userPlayers[4].player.Position" v-bind:team="this.userPlayers[4].team.Name" v-bind:points="this.userPlayers[4].stats.Pts['#text']" v-bind:firstname="this.userPlayers[4].player.FirstName" v-bind:lastname="this.userPlayers[4].player.LastName"/>
        <button id='c' class="btn btn-red" v-on:click="swapC($event)">Swap</button>
      </div>
    </div>
  </div>
</template>

<script>
import PointGuard from './components/PointGuard.vue'
import ShootingGuard from './components/ShootingGuard.vue'
import SmallForward from './components/SmallForward.vue'
import PowerForward from './components/PowerForward.vue'
import Center from './components/Center.vue'
import axios from 'axios'
import btoa from 'btoa'
import missinglogo from './assets/shrug.svg'


export default {
  name: 'app',
  data () {
    return {
      players: null,
      pointGuards: [],
      shootingGuards: [],
      smallForwards: [],
      powerForwards: [],
      centers: [],
      guardsForwards: [],
      cpuPlayers: [],
      userPlayers: [],
      cpuImages: [],
      userImages: [],
      pgSwap: 0,
      sgSwap: 0,
      sfSwap: 0,
      pfSwap: 0,
      cSwap: 0,
      cpuWins: 0,
      userWins: 0,
      pointsShown: false
    }
  },
  methods: {
    playAgain: function () {
      this.players = null;
      this.pointGuards = [];
      this.shootingGuards = [];
      this.smallForwards = [];
      this.powerForwards = [];
      this.centers = [];
      this.guardsForwards = [];
      this.cpuPlayers = [];
      this.userPlayers = [];
      this.cpuImages = [];
      this.userImages = [];
      this.pgSwap = 0;
      this.sgSwap = 0;
      this.sfSwap = 0;
      this.pfSwap = 0;
      this.cSwap = 0;
      this.pointsShown = false

      document.getElementById('pg').style.visibility = 'visible';
      document.getElementById('sg').style.visibility = 'visible'
      document.getElementById('sf').style.visibility = 'visible'
      document.getElementById('pf').style.visibility = 'visible'
      document.getElementById('c').style.visibility = 'visible'

      const now = new Date();
      now.setDate(now.getDate() - 1);
      const yest  = now.toISOString().slice(0,10).replace(/-/g,"");
      console.log(yest);

      axios({
        method: 'get',
        url: "https://api.mysportsfeeds.com/v1.2/pull/nba/2018-2019-regular/daily_player_stats.json?fordate=20190329",
        headers: {
          'Authorization': "Basic " + btoa("d442e091-6d15-4d90-8aa0-6d5b41" +  ":" + "N!ck40o0")
        }
      }).then(response => {
        console.log(response.data.dailyplayerstats.playerstatsentry);
        this.players = response.data.dailyplayerstats.playerstatsentry;

        let point = [];
        let shooting = [];
        let small =[];
        let power = [];
        let center = [];
        //Abbr for Guards or Forwards
        let gorf = [];
        
        //Seperates players into different arrays based upon position
        for (let index = 0; index < this.players.length; index++) {
          
          if (this.players[index].player.Position == "PG") {
            point.push(this.players[index].player.ID);
          }else if (this.players[index].player.Position == "SG") {
            shooting.push(this.players[index].player.ID);
          }else if (this.players[index].player.Position == "SF") {
            small.push(this.players[index].player.ID);
          }else if (this.players[index].player.Position == "PF") {
            power.push(this.players[index].player.ID);
          }else if (this.players[index].player.Position == "C") {
            center.push(this.players[index].player.ID);
          }else {
            gorf.push(this.players[index].player.ID);
          }
        }
        
        //Gathers the player ID's for all players in the this.players array
        function seperation (array1, array2, array3) {
          array1.forEach(element => {
            const found = array2.find(elem => {
              return elem.player.ID == element;
            })
            array3.push(found);
          })
        }

        seperation(point, this.players, this.pointGuards);
        seperation(shooting, this.players, this.shootingGuards);
        seperation(small, this.players, this.smallForwards);
        seperation(power, this.players, this.powerForwards);
        seperation(center, this.players, this.centers);
        
        //Selects a player from each position at random to add to both the cpu team and user team (removes selected players from array so the same player can't be used on both teams)
        function pushPlayers (array, array2, array3) {
          const cpu1 = array[Math.floor(Math.random() * array.length)];
          array2.push(cpu1);
          const index1 = array.indexOf(cpu1);
          array.splice(index1, 1);
          const player1 = array[Math.floor(Math.random() * array.length)];
          array3.push(player1);
        }

        pushPlayers(this.pointGuards, this.cpuPlayers, this.userPlayers);
        pushPlayers(this.shootingGuards, this.cpuPlayers, this.userPlayers);
        pushPlayers(this.smallForwards, this.cpuPlayers, this.userPlayers);
        pushPlayers(this.powerForwards, this.cpuPlayers, this.userPlayers);
        pushPlayers(this.centers, this.cpuPlayers, this.userPlayers);

        console.log(this.cpuPlayers);
        console.log(this.userPlayers);

        //Had to use async/await and for...of loop because forEach loop was pushing objects into array out of order
        async function getImages(array, array2) {
          for (const player of array) {
            const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + player.player.LastName + "/" + player.player.FirstName);
            const res = await imageCall;
            if (res.data == "Sorry, that player was not found. Please check the spelling.") {
              array2.push(missinglogo);
            }else {
              array2.push(res.config.url);
            }
            
            // console.log(res);
          }
        }

        getImages(this.cpuPlayers, this.cpuImages);
        getImages(this.userPlayers, this.userImages);

        // console.log(this.cpuImages);
        // console.log(this.userImages);

      }).catch(error => {
        console.error(error)
      })
    },
    swapPG: async function (event) {
      
      event.preventDefault();
      if (this.pgSwap == 0) {
        const newPlayer = this.pointGuards[Math.floor(Math.random() * this.pointGuards.length)];
      
        this.userPlayers.splice(0, 1, newPlayer);

        this.pgSwap++;
        const parent = document.getElementById('grid-item1');
        const child = document.getElementById('pg');
        child.style.visibility = 'hidden'

        const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + newPlayer.player.LastName + "/" + newPlayer.player.FirstName);
        const res = await imageCall;
        if (res.data == "Sorry, that player was not found. Please check the spelling.") {
          this.userImages.splice(0, 1, missinglogo);
        }else {
          this.userImages.splice(0, 1, res.config.url);
        }
      }
    },

    swapSG: async function (event) {
      
      event.preventDefault();
      if (this.sgSwap == 0) {
        const newPlayer = this.shootingGuards[Math.floor(Math.random() * this.shootingGuards.length)];
      
        this.userPlayers.splice(1, 1, newPlayer);

        const child = document.getElementById('sg')
        child.style.visibility = 'hidden'

        const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + newPlayer.player.LastName + "/" + newPlayer.player.FirstName);
        const res = await imageCall;
        if (res.data == "Sorry, that player was not found. Please check the spelling.") {
          this.userImages.splice(1, 1, missinglogo);
        }else {
          this.userImages.splice(1, 1, res.config.url);
        }
      }
    },
    
    swapSF: async function (event) {
      
      event.preventDefault();
      if (this.sfSwap == 0) {
        const newPlayer = this.smallForwards[Math.floor(Math.random() * this.smallForwards.length)];
      
        this.userPlayers.splice(2, 1, newPlayer);

        const child = document.getElementById('sf')
        child.style.visibility = 'hidden'

        const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + newPlayer.player.LastName + "/" + newPlayer.player.FirstName);
        const res = await imageCall;
        if (res.data == "Sorry, that player was not found. Please check the spelling.") {
          this.userImages.splice(2, 1, missinglogo);
        }else {
          this.userImages.splice(2, 1, res.config.url);
        }
      }
      
    },

    swapPF: async function (event) {
      
      event.preventDefault();
      if (this.pfSwap == 0) {
        const newPlayer = this.powerForwards[Math.floor(Math.random() * this.powerForwards.length)];
      
        this.userPlayers.splice(3, 1, newPlayer);

        const child = document.getElementById('pf')
        child.style.visibility = 'hidden'

        const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + newPlayer.player.LastName + "/" + newPlayer.player.FirstName);
        const res = await imageCall;
        if (res.data == "Sorry, that player was not found. Please check the spelling.") {
          this.userImages.splice(3, 1, missinglogo);
        }else {
          this.userImages.splice(3, 1, res.config.url);
        }
      }
      
    },

    swapC: async function (event) {
      
      event.preventDefault();
      if (this.cSwap == 0) {
        const newPlayer = this.centers[Math.floor(Math.random() * this.centers.length)];
      
        this.userPlayers.splice(4, 1, newPlayer);

        const child = document.getElementById('c')
        child.style.visibility = 'hidden'

        const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + newPlayer.player.LastName + "/" + newPlayer.player.FirstName);
        const res = await imageCall;
        if (res.data == "Sorry, that player was not found. Please check the spelling.") {
          this.userImages.splice(4, 1, missinglogo);
        }else {
          this.userImages.splice(4, 1, res.config.url);
        }
      }
      
    },

    compare: function () {

      this.pointsShown = true;
      console.log(this.pointsShown);
      let cpuScore = 0;
      let userScore = 0;

      for (let index = 0; index < this.cpuPlayers.length; index++) {
        const score = this.cpuPlayers[index].stats.Pts['#text'];
        cpuScore += parseInt(score)
      }

      for (let index = 0; index < this.userPlayers.length; index++) {
        const score = this.userPlayers[index].stats.Pts['#text'];
        userScore += parseInt(score)
      }

      console.log(cpuScore);
      console.log(userScore);
      
      if (cpuScore > userScore) {
        alert('You Lose');
        this.cpuWins++;
      }else if (userScore > cpuScore) {
        alert('You Win');
        this.userWins++;
      }else if (cpuScore == userScore) {
        alert('Tie Game')
      }
    }
  },
  mounted () {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    const yest  = now.toISOString().slice(0,10).replace(/-/g,"");
    console.log(yest);

    axios({
      method: 'get',
      url: "https://api.mysportsfeeds.com/v1.2/pull/nba/2018-2019-regular/daily_player_stats.json?fordate=20190329",
      headers: {
        'Authorization': "Basic " + btoa("d442e091-6d15-4d90-8aa0-6d5b41" +  ":" + "N!ck40o0")
      }
    }).then(response => {
      console.log(response.data.dailyplayerstats.playerstatsentry);
      this.players = response.data.dailyplayerstats.playerstatsentry;

      let point = [];
      let shooting = [];
      let small =[];
      let power = [];
      let center = [];
      //Abbr for Guards or Forwards
      let gorf = [];
      
      //Seperates players into different arrays based upon position
      for (let index = 0; index < this.players.length; index++) {
        
        if (this.players[index].player.Position == "PG") {
          point.push(this.players[index].player.ID);
        }else if (this.players[index].player.Position == "SG") {
          shooting.push(this.players[index].player.ID);
        }else if (this.players[index].player.Position == "SF") {
          small.push(this.players[index].player.ID);
        }else if (this.players[index].player.Position == "PF") {
          power.push(this.players[index].player.ID);
        }else if (this.players[index].player.Position == "C") {
          center.push(this.players[index].player.ID);
        }else {
          gorf.push(this.players[index].player.ID);
        }
      }
      
      //Gathers the player ID's for all players in the this.players array
      function seperation (array1, array2, array3) {
        array1.forEach(element => {
          const found = array2.find(elem => {
            return elem.player.ID == element;
          })
          array3.push(found);
        })
      }

      seperation(point, this.players, this.pointGuards);
      seperation(shooting, this.players, this.shootingGuards);
      seperation(small, this.players, this.smallForwards);
      seperation(power, this.players, this.powerForwards);
      seperation(center, this.players, this.centers);
      
      //Selects a player from each position at random to add to both the cpu team and user team (removes selected players from array so the same player can't be used on both teams)
      function pushPlayers (array, array2, array3) {
        const cpu1 = array[Math.floor(Math.random() * array.length)];
        array2.push(cpu1);
        const index1 = array.indexOf(cpu1);
        array.splice(index1, 1);
        const player1 = array[Math.floor(Math.random() * array.length)];
        array3.push(player1);
      }

      pushPlayers(this.pointGuards, this.cpuPlayers, this.userPlayers);
      pushPlayers(this.shootingGuards, this.cpuPlayers, this.userPlayers);
      pushPlayers(this.smallForwards, this.cpuPlayers, this.userPlayers);
      pushPlayers(this.powerForwards, this.cpuPlayers, this.userPlayers);
      pushPlayers(this.centers, this.cpuPlayers, this.userPlayers);

      console.log(this.cpuPlayers);
      console.log(this.userPlayers);

      //Had to use async/await and for...of loop because forEach loop was pushing objects into array out of order
      async function getImages(array, array2) {
        for (const player of array) {
          const imageCall = await axios.get("https://nba-players.herokuapp.com/players/" + player.player.LastName + "/" + player.player.FirstName);
          const res = await imageCall;
          if (res.data == "Sorry, that player was not found. Please check the spelling.") {
            array2.push(missinglogo);
          }else {
            array2.push(res.config.url);
          }
          
          // console.log(res);
        }
      }

      getImages(this.cpuPlayers, this.cpuImages);
      getImages(this.userPlayers, this.userImages);

      // console.log(this.cpuImages);
      // console.log(this.userImages);

    }).catch(error => {
      console.error(error)
    })
  },
  components: {
    PointGuard,
    ShootingGuard,
    SmallForward,
    PowerForward,
    Center
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Bungee+Shade');

body {
  background-image: url("./assets/basketballcourt.jpg");
  background-repeat: no-repeat;
  background-position: center
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: whitesmoke;
  margin: auto;
}

.ticker {
  font-family: 'Bungee Shade', cursive;
  background-color: black;
  font-size: inherit
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  justify-content: space-evenly
}

.grid-container img {
  width: 170px;
  height: 170px
}

.grid-container2 {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  justify-content: space-evenly
}

.grid-container2 img {
  width: 170px;
  height: 170px
}

.btn {	
	border-color: rgba(0,0,0,0.3);
	text-shadow: 0 1px 0 rgba(0,0,0,0.5);
	color: #FFF;
	display: inline-block;
	text-transform: uppercase;
	letter-spacing: 2px;
	font-size: 12px;
	padding: 10px 30px;
	border-radius: 5px;
	-moz-border-radius: 5px;
	-webkit-border-radius: 5px;
	border: 1px solid rgba(0,0,0,0.3);
	border-bottom-width: 3px;
}

.btn-grn {
  background-color: #7EA16B;
}

.btn-grn:hover {
  background-color: #596F62;
  border-color: rgba(0,0,0,0.5);
}

.btn-org {
  background-color: #BB6B00;
  border-color: rgba(0,0,0,0.9);
}

.btn-org:hover {
  background-color: #894E00;
  border-color: rgba(0,0,0,0.9);
}

.btn-red {
  background-color: #E48681;
}

.btn-red:hover {
  background-color: #DA4F49;
  border-color: rgba(0,0,0,0.5);
}

</style>
